import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { WorkstationCategoryDTO } from '../../workstation-category/dto/workstation-category.dto';
export class ProductConversionRequestDto {
  @ApiProperty()
  @IsNotEmpty({message:"Product Conversion id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  productConversionId: number;

  @ApiProperty()
  @IsNotEmpty({message:"To sale Order id should not be empty"})
  @IsAlphanumeric()
  toSaleOrder: number;

  @ApiProperty()
  @IsNotEmpty({message:"From sale Order id should not be empty"})
  @IsAlphanumeric()
  fromSaleOrder: number;

  @ApiProperty()
  @IsNotEmpty({message:"To sale Order Item id should not be empty"})
  @IsAlphanumeric()
  toSaleOrderItemId: number;

  @ApiProperty()
  @IsNotEmpty({message:"From sale Order Item id should not be empty"})
  @IsAlphanumeric()
  fromSaleOrderItemId: number;

  @ApiProperty()
  @IsNotEmpty({message:"quantity should not be empty"})
  @IsAlphanumeric()
  quantity: number;

  @ApiProperty()
  @IsNotEmpty({message:"boxes should not be empty"})
  @IsAlphanumeric()
  boxes: number;

  @ApiProperty()
  @IsNotEmpty({message:"production Inv Id should not be empty"})
  @IsAlphanumeric()
  prodInvId: number;

  @ApiProperty()
  @IsNotEmpty({message:"plant Id should not be empty"})
  @IsAlphanumeric()
  plantId: number;

  @ApiProperty()
  @IsNotEmpty({message:"Converted production Inv Id should not be empty"})
  @IsAlphanumeric()
  convertedProdInvId: number;

  @ApiProperty()
  @MaxLength(30, { message: "Lot Code allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Lot Code should be only alpha numeric" })
  lotCode: string;

  @ApiProperty()
  @MaxLength(30, { message: "Reason allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Reason should be only alpha numeric" })
  conversionReason: string;

  @ApiProperty()
  @MaxLength(30, { message: "From Operation allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"From Operation should be only alpha numeric" })
  fromOperation: string;

  @ApiProperty()
  @MaxLength(30, { message: "to Operation allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"to Operation should be only alpha numeric" })
  toOperation: string;

  @ApiProperty()
  @MaxLength(30, { message: "currency allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"currency should be only alpha numeric" })
  remarks: string;


  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

}

